/**
 * 全局静态属性配置文件
 */
const config = {
    langCode:'lang',                                            //默认语言接口参数名
    lang: 'zh_CN',                                              //语言值
	isFirst:'isfirst',   
	apiPath : uni.getStorageSync('serverAdress')||"https://api.sjkjgz.com",  
	// apiPath:window.$store.state.resInfo||"http://api.sjkjgz.com";//测试服务器网关地址
	// baseUrl: 'http://b2b.sjkjgz.com', //二维码生成地址前缀
	// registUrl:'http://regist.sjkjgz.com/',//邀请注册地址
    loginToken: "Basic YXBwOmFwcA==",               //登录接口的头部信息
    headerCompanyParam:"user_company",                          //头部参数
    headerUsernameParam:'username',
    headerUserIdParam:'userId',
    Authorization:"Authorization",
    noLoginUrl:"/api/open/",
    loginUrl:"/amc/password/token",
	refreshTokenUrl:"/amc/oauth2/token",
	logoutUrl:"/amc/logout/token",
    phoneLoginUrl:"/amc/phone/token",
    thirdLoginUrl:"/amc/third/token",
    access_token_key:"access_token",
    access_token_exprie_key:"token_access_token_exprie",
    refresh_token_key:"refresh_token",
}
export default config;